import { render, staticRenderFns } from "./EditPopup.vue?vue&type=template&id=23a5964c&scoped=true&"
import script from "./EditPopup.vue?vue&type=script&lang=js&"
export * from "./EditPopup.vue?vue&type=script&lang=js&"
import style0 from "./EditPopup.vue?vue&type=style&index=0&id=23a5964c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a5964c",
  null
  
)

export default component.exports